import AppShell from "../components/layout/AppShell";
import CockpitIdentity from "../components/common/CockpitIdentity";
import CockpitTabs from "../components/common/CockpitTabs";
import ManualTradeCard from "../components/manual/ManualTradeCard";
import ManualRangeCard from "../components/manual/ManualRangeCard";
import ManualPositionsPanel from "../components/manual/ManualPositionsPanel";
import { useManualCockpit } from "../hooks/useManualCockpit";

/**
 * Page du cockpit MANUEL (dual-cockpit 2026-07-30 ; range-only 2026-09-01 —
 * le panneau solde et le ticket libre sont retirés, la page est la maison de
 * l'automate range) — sur son compte dédié (BX9MT en LIVE ; ZSKS6 partagé en
 * DEMO). Zéro couplage avec l'AUTO : autre passerelle, autre table, autre
 * carte. Identité visuelle bleue (info) vs cyan AUTO.
 */
export default function ManualCockpitPage() {
  const manual = useManualCockpit();
  const shared = manual.status?.sharedWithBot ?? false;

  return (
    <AppShell>
      <div className="mb-4 flex flex-col gap-4">
        <CockpitTabs />
        <CockpitIdentity variant="manual" account={manual.status?.accountId ?? null} />
        {/* Avertissements opérateur — indépendants du panneau solde retiré (range-only). */}
        {shared && (
          <p className="text-warning text-xs" data-testid="manual-shared-note">
            DEMO : compte partagé avec le bot (pas de 2ᵉ compte démo). Les livres restent
            séparés par dealId, mais IG peut netter/rejeter des sens opposés sur le même
            marché.
          </p>
        )}
        {manual.status?.pendingAdoption && (
          <p className="text-warning text-xs" data-testid="manual-pending-adoption">
            Un ordre attend sa confirmation (§12) — ne pas re-soumettre à l'aveugle.
          </p>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <ManualTradeCard manual={manual} />
        <ManualRangeCard manual={manual} />
        <ManualPositionsPanel manual={manual} />
      </div>
    </AppShell>
  );
}
